import React, { useState, useEffect, useContext } from "react";

import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import api from "../../services/api";
import { notify } from "../../utils/notify";
import MaskService from "../../utils/mask/maskService";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import validTypeFile from "../../utils/validTypeFile";
import validatesNotNull from "../../utils/validatesNotNull";
import getBase64 from "../../utils/getBase64";
import { UserContext } from "../../context/UserContext";
import { GlobalVariables } from "../../global";
import Products from "./Products";
import PromocodeEdit from "./PromocodeEdit";
import PromocodeStatic from "./PromocodeStatic";
import SelectCustom from "../../components/basic/SelectCustom";
import TextFieldCustom from "../../components/basic/TextFieldCustom";
import "./.promocode.css";
import "../../styles/global.css";
import { getSegments } from "../../repositories/segmentRepository";
import { getPromoters } from "../../repositories/promoterRepository";

const CreatePromocode = () => {
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [inputSelect, setInputSelect] = useState({ CNPJ: true, CPF: false });
  const [reason, setReason] = useState("");
  const [fantasy, setFantasy] = useState("");
  const [cep, setCep] = useState("");
  const [uf, setUf] = useState("");
  const [county, setCounty] = useState("");
  const [address, setAddress] = useState("");
  const [number, setNumber] = useState("");
  const [district, setDistrict] = useState("");
  const [telephone, setTelephone] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [idSegment, setIdSegment] = useState(null);
  const [cnpjMatriz, setCnpjMatriz] = useState("");
  const [ie, setIe] = useState("");
  const [im, setIm] = useState("");
  const [complement, setComplement] = useState("");
  const [codIbge, setCodIbge] = useState("");
  const [email, setEmail] = useState("");
  const [passwordCertificate, setPasswordCertificate] = useState("");
  const [showPasswordCertific, setShowPasswordCertific] = useState(false);
  const [clientExistData, setClientExistData] = useState(false);
  const [logomarca, setLogomarca] = useState(null);
  const [removeLogomarca, setRemoveLogomarca] = useState(false);
  const [previewLogomarca, setPreviewLogomarca] = useState("");
  const [certificate, setCertificate] = useState(null);
  const [removeCertificate, setRemoveCertificate] = useState(false);
  const [previewCertificate, setPreviewCertificate] = useState("");
  const [optionsSegments, setOptionsSegments] = useState([
    { Id: 0, Descricao: "" },
  ]);
  const [promoters, setPromoters] = useState({
    IdPromotorConsultor: null,
    IdPromotorFranquia: null,
    IdPromotorContador: null,
    IdPromotorEntidade: null,
  });

  const [usersPromoter, setUsersPromoter] = useState({
    IdUsuarioConsultor: null,
    IdUsuarioFranquia: null,
    IdUsuarioContador: null,
    IdUsuarioEntidade: null,
  });
  const [active, setActive] = useState(false);
  const [errors, setErrors] = useState({});
  const [optionsPromoters, setOptionsPromoters] = useState([]);
  const [optionsUsers, setOptionsUsers] = useState([]);
  const [optionsAccountants, setOptionsAccountants] = useState([]);
  const [accountantCustomer, setAccountantCustomer] = useState(null);
  const [accountantCustomerCnpj, setAccountantCustomerCnpj] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data: result } = await getPromoters({
          params: "?IdTipoPromotor=3",
        });

        if (result?.success) {
          setOptionsAccountants(result?.data);
        }
      } catch (error) {}
    })();
  }, []);

  useEffect(() => {
    setAccountantCustomer(
      optionsAccountants.find((a) => a.CNPJ === accountantCustomerCnpj) || null
    );
  }, [accountantCustomerCnpj, optionsAccountants]);

  useEffect(() => {
    const requestSegments = async () => {
      try {
        const { data: result } = await getSegments();

        if (result && result.success) {
          setOptionsSegments(result.data || []);
        }
      } catch (error) {}
    };
    requestSegments();
  }, []);

  useEffect(() => {
    const ac = new AbortController();

    const getClientExists = async () => {
      try {
        setLoading(true);

        const cnpjRemoveMask = cnpj;

        const { data } = await api.get(
          `cliente/${cnpjRemoveMask.replace(/[^0-9]+/g, "")}`
        );

        if (data.notAllowed) {
          setCnpj("");
          setLoading(false);
          return true;
        }

        if (data) {
          setClientExistData(data.client ? true : false);
          setActive(data.company.MatrizCNPJ ? true : false);
          setCnpjMatriz(data.company.MatrizCNPJ || "");
          setIe(data.company.IE || "");
          setIm(data.company.IM || "");
          setFantasy(data.company.Fantasia);
          setReason(data.company.Razao);
          setCep(MaskService.toMask("cep", data.company.CEP || ""));
          setCounty(data.company.Municipio);
          setUf(data.company.UF);
          setAddress(data.company.Endereco);
          setNumber(data.company.Numero);
          setDistrict(data.company.Bairro);
          setTelephone(
            MaskService.toMask("cel-phone", data.company.Telefone || "")
          );
          setComplement(data.company.Complemento || "");
          setPreviewLogomarca(
            data.company.Logomarca
              ? `data:image/jpeg;base64,${data.company.Logomarca}`
              : ""
          );

          if (data.client) {
            const segDescription = optionsSegments.find(
              (seg) => seg.Id === data.client.IdSegmento
            );

            setIdSegment({
              Id: data.client.IdSegmento,
              Descricao: segDescription ? segDescription.Descricao : "",
            });
            setEmail(data.client.Email);
            setPasswordCertificate(data.client.SenhaCertificado || "");
            setPreviewCertificate(data.client.CaminhoCertificado || "");
            setAccountantCustomerCnpj(data.client.ContadorCNPJ || null);
          } else {
            setIdSegment(null);
            setEmail("");
            setPasswordCertificate("");
            setPreviewCertificate("");
            setAccountantCustomerCnpj(null);
          }

          setLoading(false);
          return true;
        } else {
          setLoading(false);
          return false;
        }
      } catch (error) {
        console.error(error);
        setLoading(false);
        ac.abort();
      }
    };

    const getDataByCNPJ = async () => {
      try {
        cleanData(false);
        const clientExist = await getClientExists();

        if (clientExist) return;

        setLoading(true);

        const cnpjRemoveMask = cnpj;

        const { data } = await api.get(
          `cliente/${cnpjRemoveMask.replace(/[^0-9]+/g, "")}/hubDev`,
          {
            timeout: 8000,
          }
        );

        const segDescription = optionsSegments.find(
          (seg) => seg.Id === data.segmentByCnae
        );

        setIdSegment(
          segDescription
            ? {
                Id: data.segmentByCnae,
                Descricao: segDescription.Descricao,
              }
            : null
        );

        if (data.client && data.client.numero_de_cpf) {
          setFantasy(data.client.nome_da_pf || "");
          setReason(data.client.nome_da_pf || "");

          return;
        }

        setFantasy(
          (!data.client.fantasia || data.client.fantasia.indexOf("**") !== -1
            ? data.client.nome
            : data.client.fantasia) || ""
        );

        setReason(data.client.nome || "");

        handleChangeCep({
          target: {
            value:
              (data.client.cep === "INFORMAÇÃO SUPRIMIDA NO TESTE"
                ? ""
                : data.client.cep) || "",
          },
        });
        setUf(data.client.uf || "");
        setCounty(data.client.municipio || "");
        setAddress(data.client.logradouro || "");
        setNumber(
          `${
            data.client.numero.indexOf("S/") !== -1 ? "0" : data.client.numero
          }` || ""
        );
        setDistrict(data.client.bairro || "");
        setComplement(
          (!data.client.complemento ||
          data.client.complemento.indexOf("**") !== -1
            ? ""
            : data.client.complemento) || ""
        );
        setTelephone(
          (data.client.telefone === "INFORMAÇÃO SUPRIMIDA NO TESTE"
            ? ""
            : data.client.telefone.substr(0, 15)) || ""
        );
      } catch (error) {
        console.error(error);

        ac.abort();
      } finally {
        setLoading(false);
      }
    };

    if (
      (inputSelect.CNPJ && cnpj.length === 18) ||
      (inputSelect.CPF && cnpj.length === 14)
    ) {
      getDataByCNPJ();
    }
  }, [cnpj, inputSelect, user, optionsSegments]);

  const handleChangeCep = async (e, findHub = true) => {
    try {
      const cepRemoveMask = e.target.value.replace(/[^0-9]+/g, "");
      setCep(MaskService.toMask("cep", e.target.value));

      if (
        !findHub ||
        cepRemoveMask === "00000000" ||
        cepRemoveMask.length !== 8
      ) {
        return;
      }

      setLoading(true);

      const { data } = await api.get(`cliente/cep/${cepRemoveMask}/hubDev`);

      if (data && data.bairro) {
        setDistrict(data.bairro || "");
        setCounty(data.localidade || "");
        setAddress(data.logradouro || "");
        setUf(data.uf || "");
        setCodIbge(data.ibge || null);
      }

      return data;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const cleanData = (cleanCnpj = true, value = { CNPJ: true, CPF: false }) => {
    if (cleanCnpj) {
      setInputSelect(value);
      setCnpj("");
    }

    setErrors({});
    setClientExistData(false);
    setCnpjMatriz("");
    setActive(false);
    setIdSegment(null);
    setIe("");
    setIm("");
    setFantasy("");
    setReason("");
    setCep("");
    setCounty("");
    setUf("");
    setAddress("");
    setNumber("");
    setDistrict("");
    setComplement("");
    setTelephone("");
    setEmail("");
    setAccountantCustomerCnpj(null);
    setLogomarca(null);
    setCertificate(null);
    setPreviewCertificate("");
    setPasswordCertificate("");
    setPreviewLogomarca("");
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      let validationFail = false;

      const requiredInputs = [
        { value: cnpj, key: "cnpj" },
        { value: fantasy, key: "fantasy" },
        { value: reason, key: "reason" },
        { value: cep, key: "cep" },
        { value: uf, key: "uf" },
        { value: county, key: "county" },
        { value: address, key: "address" },
        { value: number, key: "number" },
        { value: district, key: "district" },
        { value: telephone, key: "telephone" },
        { value: email, key: "email" },
        { value: idSegment, key: "idSegment" },
      ];

      if (active) {
        requiredInputs.push({ value: cnpjMatriz, key: "cnpjMatriz" });
      }

      if (certificate) {
        requiredInputs.push({
          value: passwordCertificate,
          key: "passwordCertificate",
        });
      }

      const resultValidation = validatesNotNull(requiredInputs);

      if (
        cnpj &&
        inputSelect.CNPJ &&
        !MaskService.isValid("cnpj", MaskService.toMask("cnpj", cnpj))
      ) {
        validationFail = true;
        resultValidation.errorsValidation.cnpj = true;
        notify("O CNPJ informado é inválido.", true, "error");
      }

      if (
        cnpj &&
        inputSelect.CPF &&
        !MaskService.isValid("cpf", MaskService.toMask("cpf", cnpj))
      ) {
        validationFail = true;
        resultValidation.errorsValidation.cnpj = true;
        notify("O CPF informado é inválido.", true, "error");
      }

      if (cep && MaskService.toMask("cep", cep).length !== 10) {
        validationFail = true;
        resultValidation.errorsValidation.cep = true;
        notify("O CEP informado é inválido.", true, "error");
      }

      if (
        telephone &&
        !MaskService.isValid(
          "cel-phone",
          MaskService.toMask("cel-phone", telephone)
        )
      ) {
        validationFail = true;
        resultValidation.errorsValidation.telephone = true;
        notify("O telefone informado é inválido.", true, "error");
      }

      if (
        active &&
        cnpjMatriz &&
        !MaskService.isValid("cnpj", MaskService.toMask("cnpj", cnpjMatriz))
      ) {
        validationFail = true;
        resultValidation.errorsValidation.cnpjMatriz = true;
        notify("O CNPJ da matriz informado é inválido.", true, "error");
      }

      if (resultValidation.error || validationFail) {
        setErrors(resultValidation.errorsValidation);
        return setLoading(false);
      } else {
        setErrors({});
      }

      const newPromotersValues = { ...promoters };

      Object.keys(newPromotersValues).forEach((element) => {
        newPromotersValues[element] = newPromotersValues[element]
          ? newPromotersValues[element].CNPJ
          : null;
      });

      const newUsersPromotersValues = { ...usersPromoter };

      Object.keys(newUsersPromotersValues).forEach((element) => {
        newUsersPromotersValues[element] = newUsersPromotersValues[element]
          ? newUsersPromotersValues[element].Id
          : null;
      });

      let cnpjRemoveMask = cnpj;
      let numberRemoveMask = number;

      const newDate = new Date();

      const data = {
        IdSegmento: idSegment?.Id || GlobalVariables.SEGMENTS.DEFAULT,
        Fantasia: fantasy.substr(0, 60),
        Razao: reason.substr(0, 90),
        CNPJ: cnpj,
        MatrizCNPJ: active ? cnpjMatriz : null,
        CEP: cep,
        UF: uf.substr(0, 2),
        Municipio: county.substr(0, 50),
        Endereco: address.substr(0, 50),
        Numero: numberRemoveMask
          .toString()
          .replace(/[^0-9]+/g, "")
          .substr(0, 50),
        Bairro: district.substr(0, 50),
        Complemento: complement.substr(0, 50),
        CodigoCidadeIBGE: codIbge.substr(0, 10),
        Telefone: telephone,
        IE: ie,
        IM: im,
        Email: email.replace(/ /g, ""),
        SenhaCertificado: passwordCertificate,

        IdTipoUsuario: parseInt(user.IdTipoUsuario),
        Promocodes: Object.assign(newPromotersValues, newUsersPromotersValues, {
          ClienteCNPJ: cnpj,
        }),
        DataLogomarca: newDate,
        DataCertificado: newDate,
        ContadorCNPJ: accountantCustomer?.CNPJ || null,
      };

      if (logomarca) {
        const logoBase64 = await getBase64(logomarca);

        if (logoBase64) data.Logomarca = logoBase64;
      }

      if (certificate) {
        const certificateBase64 = await getBase64(certificate);

        if (certificateBase64) {
          data.CaminhoCertificado = certificateBase64;
        }
      }

      let result = null;
      let text = "";

      if (clientExistData) {
        data.RemoverLogo = removeLogomarca;
        data.RemoverCertificado = removeCertificate;

        result = await api.put(
          `cliente/${cnpjRemoveMask.replace(/[^0-9]+/g, "")}`,
          data
        );
        text = "editado";
      } else {
        result = await api.post("cliente/", data);
        text = "criado";
      }

      setLoading(false);

      if (result) {
        notify(`Cliente ${text} com sucesso.`, true, "info");
        setClientExistData(true);
      }
    } catch (error) {
      notify("Não foi possível salvar cliente.", true);
      setLoading(false);
    }
  };

  const handleSelectImages = (e) => {
    if (!e.target.files[0]) return;

    if (
      !validTypeFile({
        file: e.target.files[0],
        types: ["png", "PNG", "jpg", "JPG", "jpeg", "JPEG"],
      })
    ) {
      return notify(
        "A logomarca deve respeitar os formatos: PNG, JPEG ou JPG."
      );
    }

    if (e.target.files[0].size / 1024 / 1024 > 10) {
      return notify("A logomarca deve respeitar o tamanho máximo de 10 MB.");
    }

    setLogomarca(e.target.files[0]);
    setPreviewLogomarca(URL.createObjectURL(e.target.files[0]));
  };

  const handleSelectCertificate = (e) => {
    if (!e.target.files[0]) return;

    if (!validTypeFile({ file: e.target.files[0], types: ["pfx", "PFX"] })) {
      return notify("O certificado deve respeitar o formato PFX.");
    }

    if (e.target.files[0].size / 1024 / 1024 > 10) {
      return notify("O certificado deve respeitar o tamanho máximo de 10 MB.");
    }

    setCertificate(e.target.files[0]);
    setPreviewCertificate(URL.createObjectURL(e.target.files[0]));
    setPasswordCertificate("");
  };

  return (
    <>
      {loading && <ModalLoading loading={loading} />}
      <Grid
        container
        alignItems="center"
        justify="center"
        className="wrapper fadeInDown"
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justify="center"
          item
          lg={9}
          md={10}
          sm={10}
          xs={11}
          id="formContent"
        >
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            container
            alignItems="center"
            justify="center"
          >
            <label className="title">Cliente</label>
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            container
            justify="space-between"
          >
            <ButtonGroup
              style={{
                marginBottom: 10,
                alignItems: "flex-start",
                display: "flex",
              }}
              color="primary"
              aria-label="outlined secondary button group"
            >
              <Button
                className={inputSelect.CNPJ ? "buttonOn" : "buttonOff"}
                onClick={() => {
                  if (!inputSelect.CNPJ) {
                    cleanData(true, { CNPJ: true, CPF: false });
                  }
                }}
              >
                CNPJ
              </Button>
              <Button
                className={inputSelect.CPF ? "buttonOn" : "buttonOff"}
                onClick={() => {
                  if (!inputSelect.CPF) {
                    cleanData(true, { CNPJ: false, CPF: true });
                  }
                }}
              >
                CPF
              </Button>
            </ButtonGroup>

            <Button className="buttonClean" onClick={() => cleanData()}>
              Limpar
            </Button>
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              label={inputSelect.CNPJ ? "CNPJ*" : "CPF*"}
              autoFocus
              type="text"
              value={cnpj}
              mask={inputSelect.CNPJ ? "cnpj" : "cpf"}
              setValue={setCnpj}
              error={errors.cnpj}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="IE"
              type="text"
              value={ie}
              setValue={setIe}
              error={errors.ie}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="IM"
              type="text"
              value={im}
              setValue={setIm}
              error={errors.im}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <SelectCustom
              label="Segmento*"
              keyObject="Descricao"
              value={idSegment}
              setValue={setIdSegment}
              error={errors.idSegment}
              key="select-segment"
              optionsList={optionsSegments}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={120}
              label="Fantasia*"
              type="text"
              value={fantasy}
              setValue={setFantasy}
              error={errors.fantasy}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={120}
              label="Razão*"
              type="text"
              value={reason}
              setValue={setReason}
              error={errors.reason}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              mask="cep"
              label="CEP*"
              type="text"
              value={cep}
              onChange={handleChangeCep}
              error={errors.cep}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Município*"
              type="text"
              value={county}
              setValue={setCounty}
              error={errors.county}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              label="UF*"
              type="text"
              value={uf}
              onChange={(e) => {
                if (e.target.value.length < 3) {
                  setUf(e.target.value.toString().toUpperCase());
                }
              }}
              error={errors.uf}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Endereço*"
              type="text"
              value={address}
              setValue={setAddress}
              error={errors.address}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              label="Número*"
              type="number"
              value={number.replace(/[^0-9]+/g, "")}
              onChange={(e) =>
                setNumber(
                  e.target.value.replace(/[^0-9]+/g, "").substring(0, 50)
                )
              }
              error={errors.number}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Bairro*"
              type="text"
              value={district}
              setValue={setDistrict}
              error={errors.district}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Complemento"
              type="text"
              value={complement}
              setValue={setDistrict}
              error={errors.complement}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              label="Telefone*"
              type="text"
              mask="cel-phone"
              value={telephone}
              setValue={setTelephone}
              error={errors.telephone}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              disabled={
                user.IdTipoUsuario !== GlobalVariables.ADM_QYON &&
                clientExistData
              }
              label="E-mail master*"
              type="text"
              value={email}
              onChange={(e) =>
                setEmail(e.target.value.toLowerCase().substring(0, 50))
              }
              error={errors.email}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <SelectCustom
              label="Contador"
              keyObject="Fantasia"
              value={accountantCustomer}
              setValue={setAccountantCustomer}
              error={errors.accountantCustomer}
              optionsList={optionsAccountants}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              disabled={!certificate}
              label="Senha do certificado"
              type={showPasswordCertific ? "text" : "password"}
              value={passwordCertificate}
              setValue={setPasswordCertificate}
              error={errors.passwordCertificate}
              InputProps={{
                endAdornment: (
                  <IconButton
                    className="eyePasswordIcon"
                    aria-label="toggle password visibility"
                    onClick={() =>
                      setShowPasswordCertific(!showPasswordCertific)
                    }
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {showPasswordCertific ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                ),
              }}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            {previewCertificate && previewCertificate !== "" && (
              <DescriptionOutlinedIcon
                className="previewCertificateClient"
                color="disabled"
              />
            )}
            <div>
              <form encType="multipart/form-data">
                <label className="labelUpload">
                  <CloudUploadOutlinedIcon
                    fontSize="default"
                    className={
                      previewCertificate && previewCertificate.length > 1
                        ? "cloudIconBlue"
                        : "cloudIconGray"
                    }
                  />
                  {previewCertificate && previewCertificate.length > 1
                    ? "Alterar"
                    : "Adicionar certificado"}
                  <input
                    className="inputFile"
                    accept=".pfx"
                    type="file"
                    name="certificado"
                    onChange={handleSelectCertificate}
                    value=""
                  />
                </label>
              </form>
              {previewCertificate && previewCertificate.length > 1 && (
                <label
                  className="removeFile"
                  onClick={() => {
                    setCertificate(null);
                    setPreviewCertificate("");
                    setRemoveCertificate(true);
                    setPasswordCertificate("");
                  }}
                >
                  <img
                    alt="Deletar"
                    src="img/excluir.svg"
                    className="removeImgIcon"
                  />
                  Remover
                </label>
              )}
            </div>
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            {previewLogomarca && previewLogomarca !== "" && (
              <img
                alt="Logomarca"
                src={previewLogomarca}
                className="previewLogomarcaClient"
              />
            )}
            <div>
              <form encType="multipart/form-data">
                <label className="labelUpload">
                  <CloudUploadOutlinedIcon
                    fontSize="default"
                    className={
                      previewLogomarca && previewLogomarca.length > 1
                        ? "cloudIconBlue"
                        : "cloudIconGray"
                    }
                  />
                  {previewLogomarca && previewLogomarca.length > 1
                    ? "Alterar"
                    : "Adicionar logomarca"}
                  <input
                    className="inputFile"
                    accept="image/png, image/jpeg, image/jpg,"
                    type="file"
                    name="logomarca"
                    onChange={handleSelectImages}
                    value=""
                  />
                </label>
              </form>
              {previewLogomarca && previewLogomarca.length > 1 && (
                <label
                  className="removeFile"
                  onClick={() => {
                    setLogomarca(null);
                    setPreviewLogomarca("");
                    setRemoveLogomarca(true);
                  }}
                >
                  <img
                    alt="Deletar"
                    src="img/excluir.svg"
                    className="removeImgIcon"
                  />
                  Remover
                </label>
              )}
            </div>
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={active}
                  onChange={() => {
                    setCnpjMatriz("");
                    setActive(!active);
                  }}
                  name="checkedB"
                  className="checkboxColor"
                />
              }
              label="Vincular matriz"
            />
          </Grid>

          {active && (
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              container
              justify="flex-start"
            >
              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextFieldCustom
                  label="CNPJ Matriz*"
                  type="text"
                  value={MaskService.toMask("cnpj", cnpjMatriz)}
                  mask="cnpj"
                  setValue={setCnpjMatriz}
                  error={errors.cnpjMatriz}
                />
              </Grid>
            </Grid>
          )}

          {user.IdTipoUsuario === GlobalVariables.ADM_QYON &&
            ((inputSelect.CNPJ && cnpj.length === 18) ||
              (inputSelect.CPF && cnpj.length === 14)) && (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <PromocodeEdit
                  clienteCNPJ={cnpj}
                  promoters={promoters}
                  setPromoters={setPromoters}
                  usersPromoter={usersPromoter}
                  setUsersPromoter={setUsersPromoter}
                  optionsUsers={optionsUsers}
                  setOptionsUsers={setOptionsUsers}
                  optionsPromoters={optionsPromoters}
                  setOptionsPromoters={setOptionsPromoters}
                />
              </Grid>
            )}

          <Grid item container justify="center">
            <button
              id="buttonStylePromocode"
              type="button"
              className="btn btn-info"
              onClick={handleSubmit}
            >
              Salvar
            </button>
          </Grid>

          {user.IdTipoUsuario !== GlobalVariables.ADM_QYON &&
            ((inputSelect.CNPJ && cnpj.length === 18) ||
              (inputSelect.CPF && cnpj.length === 14)) && (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <PromocodeStatic
                  clienteCNPJ={cnpj}
                  optionsUsers={optionsUsers}
                  setOptionsUsers={setOptionsUsers}
                  optionsPromoters={optionsPromoters}
                  setOptionsPromoters={setOptionsPromoters}
                  promoters={promoters}
                  usersPromoter={usersPromoter}
                  setPromoters={setPromoters}
                  setUsersPromoter={setUsersPromoter}
                />
              </Grid>
            )}

          {((inputSelect.CNPJ && cnpj.length === 18) ||
            (inputSelect.CPF && cnpj.length === 14)) && (
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Products
                cnpj={cnpj}
                email={email}
                fantasy={fantasy}
                setPromoters={setPromoters}
                promoters={promoters}
                usersPromoter={usersPromoter}
                setUsersPromoter={setUsersPromoter}
                optionsUsers={optionsUsers}
                optionsPromoters={optionsPromoters}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};
export default CreatePromocode;
